import { render } from "./SavedTablesFilterBar.vue?vue&type=template&id=daa0f624"
import script from "./SavedTablesFilterBar.vue?vue&type=script&lang=js"
export * from "./SavedTablesFilterBar.vue?vue&type=script&lang=js"

import "./SavedTablesFilterBar.vue?vue&type=style&index=0&id=daa0f624&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__